import mergeTw from 'features/common/utils/mergeClasses'
import React from 'react'
interface InputProps extends React.HTMLProps<HTMLInputElement> {
    className?: string
}
const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({className, ...props}, ref) => {
        const defClasses = `flex-1
            rounded-full border-2 border-grey-70
            px-5 text-black placeholder:text-grey-20
            active:border-black 
            `
        const classes = mergeTw(defClasses, className)
        return <input ref={ref} className={classes} {...props} />
    },
)

export default Input
